import { NavBarBtnModel } from 'common/src/models';

const BULK_ACTION_SPINNER_COLOR = '#5E6681';

export function withBulkActionSpinner(buttons: NavBarBtnModel[]): NavBarBtnModel[] {
  return buttons.map((btn: NavBarBtnModel) => withBulkActionSpinnerButton(btn));
}

export function withBulkActionSpinnerButton(button: NavBarBtnModel): NavBarBtnModel {
  return { ...button, allowLoadingSpinner: true, greyIcon: false, spinnerColor: BULK_ACTION_SPINNER_COLOR };
}

export function keepBulkButtonsRef(prev: NavBarBtnModel[], next: NavBarBtnModel[]): NavBarBtnModel[] {
  const isSame = !!prev && prev.length === next.length && prev.every((btn: NavBarBtnModel, i: number) => btn === next[i]);
  return isSame ? prev : next;
}
